import { ANSWER_WIDGET_FENCE_LANG } from '@openx/components-core/lib/Markdown/widgets/answerWidgetPayload';

export type SplitAnswer = {
  visible: string;
  hiddenDetails: string | null;
};

// matches a line opening a fenced code block in the widget language, as CommonMark allows it: up to three spaces of
// indent and a fence of three or more backticks or tildes
const WIDGET_FENCE_OPENING = new RegExp(`^ {0,3}(?:\`{3,}|~{3,})[ \\t]*${ANSWER_WIDGET_FENCE_LANG}[ \\t]*$`, 'm');

export const splitAnswerAtFirstWidget = (answer: string): SplitAnswer => {
  const widgetStart = answer.search(WIDGET_FENCE_OPENING);
  if (widgetStart === -1) return { visible: answer, hiddenDetails: null };

  return { visible: answer.slice(0, widgetStart).trimEnd(), hiddenDetails: answer.slice(widgetStart) };
};
